import { FileInputRenderer } from '@exam-center/components';
import {
  DownloadProctorAgreementFormHelperText,
  ProctorType,
} from '@exam-center/proctor-request-management';
import { Alert, Flex, SectionTitle, Text } from '@shared/components';

export default function ThirdProctorDocumentFormFields() {
  return (
    <Flex sx={(theme) => ({ gap: theme.spacing(6), flexDirection: 'column' })}>
      <SectionTitle title='เอกสารสำคัญ' />
      <Alert severity='info' sx={{ width: '100%', fontWeight: 400 }}>
        <Flex sx={{ gap: (theme) => theme.spacing(3) }}>
          <Text
            component='span'
            sx={{
              color: (theme) => theme.palette.info.darker,
            }}
          >
            คุณสามารถอัปโหลดเอกสารแต่ละประเภทได้สูงสุด 4 ไฟล์ (ขนาดไฟล์รวมกันต้องไม่เกิน 20 MB)
          </Text>
        </Flex>
      </Alert>

      <Flex sx={(theme) => ({ gap: theme.spacing(6), flexDirection: 'column' })}>
        <FileInputRenderer
          mode='input'
          name='document.agreementForms'
          slotProps={{
            label: 'แบบฟอร์มข้อตกลงก่อนปฏิบัติหน้าที่ผู้คุมสอบ',
            placeholder: 'กรุณาอัปโหลดไฟล์ .JPG หรือ .JPEG หรือ .PNG หรือ .PDF',
            helperText: (
              <DownloadProctorAgreementFormHelperText proctorType={ProctorType.TYPE_THREE} />
            ),
            required: true,
          }}
        />
        <FileInputRenderer
          mode='input'
          name='document.identifications'
          slotProps={{
            label: 'สำเนาบัตรประชาชนและรูปถ่ายหน้าตรง',
            placeholder: 'กรุณาอัปโหลดไฟล์ .JPG หรือ .JPEG หรือ .PNG หรือ .PDF',
            required: true,
          }}
        />
      </Flex>
    </Flex>
  );
}
